// 연습 체크 칸 — 줄당 5칸 고정(바를 정 正처럼 다섯씩 세기), 마지막 줄도 같은 열에 맞춘다.
// 칸은 최대 40px(아주 좁은 화면에서만 줄어듦), 간격은 폭을 채우도록 늘어난다(영역 최대 360px). 탭하면
// 그 칸까지 채우고, 채워진 칸을 탭하면 그 앞까지로 되돌린다.
import React from 'react';
import { Box, ButtonBase } from '@mui/material';

export default function PracticeChecks({ target, done, onChange, title }) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(5, minmax(0, 40px))',
        // 칸 크기는 그대로 두고 남는 폭을 칸 사이 간격으로 나눠 아래 버튼 폭에 맞춘다.
        // 넓은 화면에서는 간격이 40px를 넘지 않도록 영역을 360px로 묶어 가운데 둔다.
        justifyContent: 'space-between',
        gap: '8px',
        maxWidth: 360,
        mx: 'auto',
      }}
    >
      {Array.from({ length: target }, (_, i) => {
        const filled = i < done;
        return (
          <ButtonBase
            key={i}
            onClick={() => onChange(filled ? i : i + 1)}
            aria-label={`${title} ${i + 1}회 ${filled ? '취소' : '완료'}`}
            sx={{ aspectRatio: '1', borderRadius: '50%' }}
          >
            <Box
              sx={{
                width: '100%',
                height: '100%',
                borderRadius: '50%',
                border: filled ? 'none' : '1.5px solid',
                borderColor: 'primary.main',
                bgcolor: filled ? 'primary.main' : 'transparent',
                transition: 'background-color 0.12s',
              }}
            />
          </ButtonBase>
        );
      })}
    </Box>
  );
}
